import { render, staticRenderFns } from "./DfSolution.vue?vue&type=template&id=b8725a84&"
import script from "./DfSolution.vue?vue&type=script&lang=js&"
export * from "./DfSolution.vue?vue&type=script&lang=js&"
import style0 from "./DfSolution.vue?vue&type=style&index=0&id=b8725a84&prod&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports